

import React from "react";
import {lowerCase, startCase} from 'lodash';

class InfoFeedCard extends React.Component {

    renderLines() {
        let lines = []
        Object.keys(this.props.data).forEach(key => {
                lines.push(
                    <div className={'data-line'} key={key}>
                        {key.charAt(0) !== '_' &&
                            <span className={'has-text-weight-light mr-5'}
                                  style={{width: '40%', display: 'inline-block', maxWidth: 110, minWidth: 80, overflow: 'ellipsis'}}>
                                {startCase(key)}
                            </span>
                        }
                        <span className={'has-text-weight-medium'}>
                            {this.props.data[key]}
                        </span>
                    </div>
                )

        })

        return lines;
    }

    render() {
        return (
                <div className="card info-feed-card mb-3">
                    <header className="card-header">
                        <p className="card-header-title">
                            {startCase(this.props.title)}
                        </p>
                    </header>
                    <div className="card-content">
                        <div className="content">
                            {this.renderLines()}
                        </div>
                    </div>
                </div>
        )
    }

}

export default class InfoFeed extends React.Component {

    static defaultProps = {
        data: [],
    };

    renderCards = () => {
        return Object.keys(this.props.data).reverse().map(key => (
            <InfoFeedCard
                key={key}
                title={key}
                data={this.props.data[key]}
            />
        ))
    }

    render() {
        return (
            <div className={'info-feed'}>
                {this.renderCards()}
                {this.props.children}
            </div>
        )
    }

}




/* data format is an array of dictionaries, each internal dictionary representing one card in the info feed. So:
so the actual format here, for a feed with one card with the title "Personal Info" would be
{
    personal_info: {
            name: "Morgan Hartley",
            email: "morganhartley@gmail.com"
        }
}

If you don't want to display the title, simply precede the key with an underscore. Such that:
     {
    _personal_info: {
            _name: "Morgan Hartley",
            _email: "morganhartley@gmail.com"
        }
}

//note that key with a null value will not display a dictionary.

{
    personal_info: null
}

*/
